import { createSlice } from "@reduxjs/toolkit";

const initialState={
    baseUrl: "https://quirckart.in/",
}

const ApiBaseUrlSlice= createSlice({
    name:"ApiBaseUrl",
    initialState,
    reducers:{
        setApiBaseUrl:(state,action)=>{
            state.baseUrl=action.payload;
        }
    }
});

export const{
    setApiBaseUrl
}=ApiBaseUrlSlice.actions;
export default ApiBaseUrlSlice.reducer;

